import { FormController } from "$root/third-party-integrations/react-hook-form";
import { valueByPath } from "$root/utils";
import type { StylableProps } from "@mdotm/shadcn/legacy/components";
import { type TextAreaProps, TextArea, FormField } from "@mdotm/shadcn/mdotm/components";
import type { ReactNode } from "react";
import type { Control, FieldValues, FormState, Path } from "react-hook-form";

export type TextFieldProps<T extends FieldValues> = StylableProps & {
	control: Control<T, any>;
	formState: FormState<T>;
	name: Path<T>;
	label: ReactNode;
} & Omit<TextAreaProps, "value">;

export function TextAreaField<T extends FieldValues>({
	label,
	name,
	formState,
	control,
	className,
	style,
	...forward
}: TextFieldProps<T>): React.JSX.Element {
	return (
		<FormField
			className={className}
			style={style}
			label={label}
			error={(valueByPath(formState.errors, name) as { message?: string })?.message}
		>
			{(fieldProps) => (
				<FormController
					control={control}
					name={name}
					render={({ field: { ref, ...controllerProps } }) => (
						<TextArea
							innerRef={ref}
							className="[&>textarea]:overflow-y-scroll"
							{...fieldProps}
							{...controllerProps}
							{...forward}
						/>
					)}
				/>
			)}
		</FormField>
	);
}
